import { render, staticRenderFns } from "./LibraryAddShelf.vue?vue&type=template&id=5ffc15bc&scoped=true&"
import script from "./LibraryAddShelf.vue?vue&type=script&lang=js&"
export * from "./LibraryAddShelf.vue?vue&type=script&lang=js&"
import style0 from "./LibraryAddShelf.vue?vue&type=style&index=0&id=5ffc15bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffc15bc",
  null
  
)

export default component.exports